import { toPluginModelElement } from '@/services/pluginsManager/adapters/toPluginModelElement';
import { openBioEntityDrawerById, selectTab } from '@/redux/drawer/drawer.slice';
import { AppDispatch } from '@/redux/store';
import { FeatureLike } from 'ol/Feature';
import { PluginsEventBus } from '@/services/pluginsManager/pluginsEventBus';
import { searchFitBounds } from '@/services/pluginsManager/map/triggerSearch/searchFitBounds';
import { FEATURE_TYPE } from '@/constants/features';
import { ModelElement } from '@/types/models';
import { addNumbersToEntityNumberData } from '@/redux/entityNumber/entityNumber.slice';
import { setModelElementSearch } from '@/redux/modelElements/modelElements.slice';
import { handleOpenImmediateLink } from '@/components/Map/MapViewer/utils/listeners/mapSingleClick/handleOpenImmediateLink';
import { setPerfectMatch, setSearchQuery } from '@/redux/search/search.slice';
import { setCurrentSelectedBioEntityId } from '@/redux/contextMenu/contextMenu.slice';

/* prettier-ignore */
export const clickHandleAlias =
  (dispatch: AppDispatch, hasFitBounds = false) =>
    async (modelElements: Array<ModelElement>, feature: FeatureLike, modelId: number): Promise<void> => {
      const id = feature.get('id');

      const modelElement = modelElements.find(element =>
        element.id === id
      );
      if(!modelElement) {
        return;
      }
      handleOpenImmediateLink(modelElement);


      dispatch(setSearchQuery(`element:${id.toString()}`));
      dispatch(setPerfectMatch(true));

      dispatch(selectTab(`${id}`));
      dispatch(openBioEntityDrawerById(id));

      dispatch(setModelElementSearch({ modelElement, perfect: true }));
      dispatch(addNumbersToEntityNumberData([modelElement.id]));
      dispatch(setCurrentSelectedBioEntityId(id));

      const searchValue = { id, modelId, type: FEATURE_TYPE.ALIAS };
      PluginsEventBus.dispatchEvent('onSearch', {
        type: 'bioEntity',
        searchValues: [searchValue],
        results: [[{
          perfect: true,
          bioEntity: toPluginModelElement(modelElement)
        }]
        ],
      });
      PluginsEventBus.dispatchEvent('onBioEntityClick', searchValue);


      if (hasFitBounds) {
        searchFitBounds();
      }
    };
